import React, { useEffect, useState } from "react";
import styles from "./createEvent.module.css";
import FormFields from "@components/Form";
import SaveButton from "components/SaveButton";
import {
  GetEventBody,
  postData,
  SearchOptions,
  updateData,
} from "utils/queries";
import { useNavigate } from "react-router-dom";
import CreateOptions from "components/Event/CreateOptions";
import PopUpModal from "common/Popup";
import Toast, { isToday } from "utils";
import {
  getFirstFormFields,
  getFourthFormFields,
  getImageFormField,
  getSecondFormFields,
  getThirdFormFields,
} from "fields/Event/createEvent";
import Incentive_ from "components/Event/IncentivePreview";
import Question from "components/Event/QuesionPreview";

const Event = ({ event_id, data }) => {
  const [eventDetails, setEventDetails] = useState({
    has_refund: false,
    age_restrictions:18,
    booking_fee_percentage: 10,
    installment_billing_type: "monthly_cycle",
    question: [],
    ...data,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (data && Object?.keys(data)?.length) {
      setEventDetails({ 
        ...data,
        installment_plans: (data?.installment_plans || []).map(plan => 
          typeof plan === 'string' ? { label: plan.replace("installment_", "") + " Months", value: plan } : plan
        )
      });
    }
  }, [data && Object?.keys(data)?.length]);

  const handleChange = (label) => (e) => {
    setEventDetails((prevDetails) => ({
      ...prevDetails,
      [label]: e?.target ? e?.target?.value : e,
    }));
  };



  const handleSaveEvent = async (createOptions) => {    
    try {
      const type = createOptions?.type || "draft";

      const typeLabel = type;
      if (!typeLabel) {
        return Toast.info("Please Select Type");
      }

      if (event_id) {
        const body = GetEventBody(eventDetails);

        const result = await updateData(`event/events/${event_id}`, {
          ...body,
          status: type,
          event_id,
        });
        console.log("result is 11",result)
        if(result?.status===200){
          navigate("/event")
        }
      } else {
        const body = GetEventBody(eventDetails);
        // return
        const result = await postData("event/events", {
          ...body,
          status: typeLabel,
          scheduled_at: createOptions?.scheduled_at || null,
        });

        console.log("result",result)
        if(result?.status===201){
          navigate("/event")
        }else if (result?.status === 400) {
          window.scrollTo({ 
            top: document.documentElement.scrollHeight / 4, 
            behavior: "smooth" 
          });
        }

      }
    } catch (error) {
    } finally {
      setIsModalOpen(false);
      // navigate("/event");
    }
  };
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      if (isToday(eventDetails?.starts)) {
        handleSaveEvent({ type: "published" });
      } else {
        setIsModalOpen(true);
      }
    } catch (error) {}
  };

  const fetchOptions = async (search = "a") => {

     // if (search?.trim() === "") return;


    try {
      const optionsResult = await SearchOptions(
        `organisers/search?key=${search}`
      );

      const data = optionsResult.data.data;
      const result = data?.filter((e) =>
        e?.name?.toLowerCase().includes(search.toLowerCase())
      );
      return result?.map((e) => ({ value: e?.id, label: e?.name }));
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

 

  const FirstFormFields = getFirstFormFields({
    eventDetails,
    fetchOptions,
    handleChange,
  });

  const SecondFormFields = getSecondFormFields({ eventDetails, handleChange });

  const ThirdFormFields = getThirdFormFields({ eventDetails, handleChange });

  const FourthFormFields = getFourthFormFields({ eventDetails, handleChange });

  const ImageFormField = getImageFormField({ eventDetails, handleChange });

  const CreatetButtonArgs = {
    label: "Create",
    id: "active",
    name: "active",
    type: "submit",
    buttonOverrideInlineStyle: { marginRight: "1.6rem" },
  };

  const EditPublishButtonArgs = {
    label: "Publish",
    id: "active",
    name: "active",
    type: "submit",
    // type: "submit",
    buttonOverrideInlineStyle: { marginRight: "1.6rem" },
  };

  return (
    <>
      <PopUpModal
        setModalIsOpen={() => setIsModalOpen(false)}
        modalIsOpen={isModalOpen}
      >
        <CreateOptions
          setModalIsOpen={() => setIsModalOpen(false)}
          scheduled_min_date = {eventDetails?.starts}
          handleSave={handleSaveEvent}
        />
      </PopUpModal>
      <div className={styles.container}>
        <form onSubmit={handleSubmit}>
          <div className={styles.eventLabel}>Event Details</div>
          <FormFields Fields={FirstFormFields} />
          <div className={styles.Dates}>
            <FormFields Fields={SecondFormFields} />
          </div>
          <div className={styles.additionalInfoHeading}>Event Image</div>
          {/* <div className={styles.additionalInfo}>
            Improve your customer attraction
          </div> */}
          <FormFields Fields={ImageFormField} />
          <div className={styles.additionalInfoHeading}>
            Event Details / additional information
          </div>
          <div className={styles.additionalInfo}>Additional Information</div>
          <FormFields Fields={ThirdFormFields} />
          {/* <FormFields Fields={FourthFormFields} /> */}
          {/* <div className={styles.modals}> */}
            {/* {event_id && (
              <Incentive_
                eventDetails={eventDetails}
                setEventDetails={setEventDetails}
                event_id={event_id} 
              />
            )} */}
            {/* <Question
              eventDetails={eventDetails}
              setEventDetails={setEventDetails}
              event_id={event_id}
            /> */}
          {/* </div> */}
          {!event_id ? (
            <SaveButton firstButtonArgs={CreatetButtonArgs} />
          ) : (
            <SaveButton firstButtonArgs={EditPublishButtonArgs} />
          )}
        </form>
      </div>
    </>
  );
};

export default Event;
